import React, { useMemo } from "react";
import {
  ErrorIcon,
  Icon,
  InfoSignIcon,
  Pane,
  RefreshIcon,
  Text,
  TickCircleIcon,
  UpdatedIcon,
} from "evergreen-ui";

const BillStateIndicator = ({ billState, billStatesMap }) => {
  const symbol = useMemo(() => {
    switch (billState) {
      case billStatesMap.load.ready:
      case billStatesMap.save.ready:
      case billStatesMap.load.processing:
      case billStatesMap.save.processing:
        return RefreshIcon;
      case billStatesMap.load.success:
        return TickCircleIcon;
      case billStatesMap.save.success:
        return UpdatedIcon;
      case billStatesMap.load.error:
      case billStatesMap.save.error:
        return ErrorIcon;
      default:
        return InfoSignIcon;
    }
  }, [billState, billStatesMap]);

  const text = useMemo(() => {
    switch (billState) {
      case billStatesMap.load.ready:
      case billStatesMap.load.processing:
        return "Loading bill...";
      case billStatesMap.save.ready:
      case billStatesMap.save.processing:
        return "Saving bill...";
      case billStatesMap.load.success:
        return "Bill loaded";
      case billStatesMap.save.success:
        return "Bill saved";
      case billStatesMap.load.error:
        return "Error loading";
      case billStatesMap.save.error:
        return "Error saving";
      default:
        return "";
    }
  }, [billState, billStatesMap]);

  if (!billState || !billStatesMap) {
    return "No bill state available";
  }

  return (
    <Pane alignItems="center" display="flex">
      <Icon color="muted" icon={symbol} />
      <Text marginLeft={8} size={300}>
        {text}
      </Text>
    </Pane>
  );
};

export default BillStateIndicator;
